import React, { useCallback, useState } from 'react'
import ReactDOM from 'react-dom'

export const ShadowDomWrapper: React.FC<{
    children: React.ReactNode
    styles?: string
}> = ({ children, styles }) => {
    const [shadowRoot, setShadowRoot] = useState<ShadowRoot | null>(null)

    // The shadow root is created when the host element mounts, so no effect is
    // needed to mirror it into state. Styles are applied once, on first attach.
    const attachHost = useCallback(
        (host: HTMLDivElement | null) => {
            if (!host) return
            if (host.shadowRoot) {
                setShadowRoot(host.shadowRoot)
                return
            }

            const root = host.attachShadow({ mode: 'open' })
            if (styles) {
                const styleTag = document.createElement('style')
                styleTag.textContent = styles
                root.appendChild(styleTag)
            }
            setShadowRoot(root)
        },
        [styles],
    )

    return (
        <div ref={attachHost}>
            {shadowRoot && ReactDOM.createPortal(children, shadowRoot)}
        </div>
    )
}
